import { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, MessageSquare, ChevronDown } from 'lucide-react';

export const ContactDropdown = ({ 
  label = 'Contact Us', 
  className = 'btn-secondary',
  dropUp = false,
  testId = 'contact-dropdown'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const positionClass = dropUp
    ? 'bottom-full left-0 mb-2'
    : 'top-full left-0 mt-2';

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`${className} flex items-center gap-2`}
        data-testid={testId}
      >
        {label} <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: dropUp ? 5 : -5, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: dropUp ? 5 : -5, scale: 0.95 }}
            transition={{ duration: 0.15 }}
            className={`absolute ${positionClass} w-52 bg-black border border-cyan-500/30 rounded-sm shadow-2xl z-50 overflow-hidden`}
          >
            <a
              href="sms:5598801818?&body=Hi%2C%20I%27d%20like%20to%20get%20a%20quote%20for%20detailing%20services."
              className="flex items-center gap-3 px-4 py-3 text-white hover:bg-cyan-500/10 hover:text-cyan-400 transition-colors"
              data-testid={`${testId}-text`}
            >
              <MessageSquare className="w-5 h-5 text-cyan-500" />
              <span className="font-medium">Text Us</span>
            </a>
            <a
              href="tel:5598801818"
              className="flex items-center gap-3 px-4 py-3 text-white hover:bg-cyan-500/10 hover:text-cyan-400 transition-colors border-t border-white/5"
              data-testid={`${testId}-call`}
            >
              <Phone className="w-5 h-5 text-cyan-500" />
              <span className="font-medium">Call 559-880-1818</span>
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
